import { DocumentEdit } from './view';

export { default as DocumentEditSaga } from './saga';

export default DocumentEdit;
